import { Component, Input } from '@angular/core';
import { FormBuilder, FormArray, FormControl } from '@angular/forms';
import { MatCheckbox } from '@angular/material';

import { Category } from '../../categories/shared';

@Component({
  selector: 'product-suggested-in-categories-form',
  templateUrl: './product-suggested-in-categories-form.component.html',
  styleUrls: ['./product-suggested-in-categories-form.component.scss']
})
export class ProductSuggestedInCategoriesFormComponent {
  @Input() categories: Array<Category> = [];
  @Input('array') formArray: FormArray;

  checkedMap: Array<boolean> = [];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.checkedMap = [];

    this.categories.forEach(category => {
      this.checkedMap[category._id] = (this.getControlIndex(category._id) === null) ? false : true;
    });

  }

  ngAfterViewInit() {
  }

  toggleValue(category: string) {
    let controlIndex = this.getControlIndex(category),
      state = null;


    if (controlIndex !== null) {
      this.formArray.removeAt(controlIndex);
      state = false;
    } else {
      this.formArray.push(new FormControl(category));
      state = true;
    }

    // Invertimos el valor debido a un error del MatCheckbox
    this.checkedMap[category] = !state;
  }

  private getControlIndex(category: string) {
    let controlIndex = null;

    this.formArray.controls.forEach((control, index) => {
      if (control.value == category) {
        controlIndex = index;
      }
    });

    return controlIndex;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-suggested-in-categories-form/product-suggested-in-categories-form.component.ts